import { render, staticRenderFns } from "./Readable.vue?vue&type=template&id=5ea998cb&scoped=true&"
import script from "./Readable.vue?vue&type=script&lang=js&"
export * from "./Readable.vue?vue&type=script&lang=js&"
import style0 from "./Readable.vue?vue&type=style&index=0&id=5ea998cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea998cb",
  null
  
)

export default component.exports